import { render } from "./LicensedInsured.vue?vue&type=template&id=915640c0&scoped=true"
import script from "./LicensedInsured.vue?vue&type=script&lang=js"
export * from "./LicensedInsured.vue?vue&type=script&lang=js"

import "./LicensedInsured.vue?vue&type=style&index=0&id=915640c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915640c0"]])

export default __exports__